export default "__VITE_ASSET__CurA4QLC__"